import { render, staticRenderFns } from "./ProductFormProductionEmbeddable.vue?vue&type=template&id=24c2d685&"
import script from "./ProductFormProductionEmbeddable.vue?vue&type=script&lang=js&"
export * from "./ProductFormProductionEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports